// §6.3 / §11.7 — the Windows 11 desktop surface: a generated wallpaper (D-043) and the icon grid,
// which fills top-to-bottom then wraps into a second column.
//
// The grid, its drag-to-group gesture and the context menu are `host/DesktopIcons` (D-276), shared
// with the house skin — §6.5 lets neither import the other. What stays here is what is genuinely
// this skin's: the wallpaper, the class prefix its sheet styles, and Start's own name for the
// launcher (§6.3).
import { useWallpaperBackground } from '@/host/useWallpaper';
import { DesktopIcons } from '@/host/DesktopIcons';
import { COPY } from '@/copy';

export function DesktopSurface() {
  const wallpaper = useWallpaperBackground();

  return (
    <div className="win11-desktop" data-testid="desktop-surface" style={{ background: wallpaper }}>
      <DesktopIcons prefix="win11" launcherLabel={COPY.chrome.openStart} />
    </div>
  );
}
